import { decamelizeKeys } from "humps";
import { xanyahApi } from "../constants";

export const getClosures = (params) =>
	xanyahApi.get<Closure[]>("v2/closures", decamelizeKeys({ params }));
